import * as React from 'react';
import camelCase from 'lodash/camelCase';

import { IUnitTestAttributes } from '../common';
import InputControl from '../InputControl/InputControl';
import { IInputFieldProps } from '../TextInput/InputTextField';

import TextArea from './TextArea';

export interface IInputTextAreaField {
  inputProps: React.TextareaHTMLAttributes<HTMLTextAreaElement> & IUnitTestAttributes;
}

type InputTextAreaFieldProps = IInputTextAreaField & IInputFieldProps;

// tslint:disable-next-line:max-line-length
export const InputTextAreaField = React.forwardRef<HTMLTextAreaElement, React.TextareaHTMLAttributes<HTMLTextAreaElement> & InputTextAreaFieldProps>((
  props, ref
) => {
  const {
    errorMsgs,
    helperText,
    label,
    tooltipProps,
    inputProps,
  } = props;

  const isDisabled = !!(inputProps && inputProps.disabled);
  const isOptional: boolean = !!(inputProps && inputProps.required === false);
  const inputId: string = camelCase(`${label}`);

  return (
    <InputControl
      errorMsgs={errorMsgs}
      helperText={helperText}
      isDisabled={isDisabled}
      isOptional={isOptional}
      inputProps={inputProps}
      label={label}
      tooltipProps={tooltipProps}
    >
      <TextArea
        error={!!errorMsgs}
        inputProps={inputProps}
        id={inputId}
        ref={ref}
      />
    </InputControl>
  );
});

export default InputTextAreaField;
